import React, { useContext } from "react"
import PropTypes from "prop-types"
import { faHomeHeart } from "@fortawesome/pro-light-svg-icons"
import { renderIf } from "../../../FeatureToggle/FeatureToggle"

import SmartLink from "../../../layout/SmartLink/SmartLink"
import { POSTAL_TOWN_SCALE } from "../../../../utils/geographical_scales"

import {
  generateGeoPathData,
  geoAreaLocationProviderDirectoryPath,
} from "../../../../utils/paths"

import SingleGeoContext from "../../../../contexts/single_geo"
import ListItemWithIcon from "../../../ListItemWithIcon/ListItemWithIcon"
import { BodyText, InlineText, Strong } from "../../../Typography/Typography"
import LineBreak from "../../../LineBreak/LineBreak"

const careTypeParentLink = (parent) =>
  geoAreaLocationProviderDirectoryPath(
    generateGeoPathData(
      parent.geographicScale,
      parent.locationName,
      "home_care",
      parent.districtType,
    ),
  )

const HomeCareLink = ({ careType }) => {
  const {
    geographicScale,
    locationName,
    districtType,
    totalHomeCareCount,
    parent,
  } = useContext(SingleGeoContext)

  const isTownPage = geographicScale === POSTAL_TOWN_SCALE

  const pluralisedHomeCareText =
    totalHomeCareCount > 1
      ? `${totalHomeCareCount} home care agencies in ${locationName} provide`
      : `${totalHomeCareCount} home care agency in ${locationName} provides`

  const homeCareCopy = (
    <BodyText>
      {pluralisedHomeCareText} trained care professionals who deliver care in
      your own home.
    </BodyText>
  )

  const careTypePath = geoAreaLocationProviderDirectoryPath(
    generateGeoPathData(
      geographicScale,
      locationName,
      "home_care",
      districtType,
    ),
  )

  const pluraliseHomeCare =
    totalHomeCareCount === 1 ? "1 home care agency" : "home care agencies"

  const homeCareClickEvent = {
    name: "SEO - Filtered Directory - Care Type Changed - Home Care Clicked",
  }

  const RenderIfTotalCountMoreThanZero = renderIf(totalHomeCareCount > 0)
  const RenderIfTotalCountIsZero = renderIf(totalHomeCareCount === 0)

  const showSeparatorIfNotCareHome = careType !== "care_home"

  return (
    <ListItemWithIcon
      icon={faHomeHeart}
      iconSize="2x"
      showSeparator={showSeparatorIfNotCareHome}
    >
      <BodyText bold>Care in your home</BodyText>
      <RenderIfTotalCountMoreThanZero>
        {homeCareCopy}
        <SmartLink to={careTypePath} chevron clickEvent={homeCareClickEvent}>
          <InlineText brand>
            See <Strong brand>{pluraliseHomeCare}</Strong> in{" "}
            <LineBreak onDesktopOnly />
            {locationName}
          </InlineText>
        </SmartLink>
      </RenderIfTotalCountMoreThanZero>
      <RenderIfTotalCountIsZero>
        <BodyText>
          Unfortunately there are no home care agencies in {locationName}.
        </BodyText>
        {isTownPage && parent.totalHomeCareCount > 0 && (
          <SmartLink
            to={careTypeParentLink(parent)}
            chevron
            clickEvent={homeCareClickEvent}
          >
            <InlineText brand>
              See <Strong brand>home care agencies</Strong> in{" "}
              <LineBreak onDesktopOnly />
              {parent.locationName}
            </InlineText>
          </SmartLink>
        )}
      </RenderIfTotalCountIsZero>
    </ListItemWithIcon>
  )
}

HomeCareLink.propTypes = {
  careType: PropTypes.oneOf(["care_home"]),
}

HomeCareLink.defaultProps = {
  careType: undefined,
}

export default HomeCareLink
